module.exports = __webpack_public_path__ + "img/arrow-right-from-line.be45fb61.svg";